export const notificationConstants = {
    CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
};
